/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import React from 'react';
import './PortalTilesContainer.css';
import { useTranslation } from '../Translation/translationProvider';
import { head } from 'lodash';
import { redirectionUrl } from '../../../utils/FRCallBackUtil';

interface TileProps {
  header: string;
  body: string;
  url?: string;
}

const Tile: React.FC<TileProps> = ({ header, body, url }) => {
  const {t} = useTranslation();
  const handleEnter = () => {
    if(url) {window.location.href = url;}
  };
  return (
    <div>
      <div className="tile">
        {header && <h3 className="tile-header">{header}</h3> }
        {body && <p className="tile-body">{body}</p>}
        <div className='tile-button-container'> {url && <button className="tile-button" onClick={handleEnter}>
          Enter <span className="arrow">→</span>
        </button>} </div>
      </div>
    </div>

  );
};

const Tiles: React.FC = () => {
  const allowedTiles = import.meta.env.VITE_ALLOWED_ADDITIONAL_TILES.split(',');
  const {t} = useTranslation();
  let tiles = null;
  tiles = [
    {
      portalName:"customer",
      header: t('portalContainer.portalPWCCustomer.header'),
      body: t('portalContainer.portalPWCCustomer.content'),
      url: redirectionUrl("customer"),
    },
    {
       portalName:"supplier",
      header: t('portalContainer.portalPWCSupplier.header'),
      body: t('portalContainer.portalPWCSupplier.content'),
      url: redirectionUrl("supplier"),
    },
    
    {
      portalName:"supplier",
      header: t('portalContainer.portalPWPoland.header'),
      body: t('portalContainer.portalPWPoland.content'),
      url: redirectionUrl("poland"),
    },
    {
      portalName:"raytheon",
      header: t('portalContainer.raytheon.header'),
      body: t('portalContainer.raytheon.content'),
      url: redirectionUrl("ciam")
    },
    {
     portalName:"clrs",
     header: t('portalContainer.portalRTXclrs.header'),
     body: t('portalContainer.portalRTXclrs.content'),
     url: redirectionUrl("clrs")
   }
  ];

  return (
    <div>
      {/* <p className="sub-header" dangerouslySetInnerHTML={{ __html: t('portalContainer.subHeader') }}></p> */}

      <div className="tiles-container">
        {tiles.map(({portalName,header, body, url }) => (
          allowedTiles.includes(portalName.toLowerCase()) ?
          <Tile key={header} header={header} body={body} url={url} /> : <></> 
        ))}
      </div>
    </div>
  );
};

export default Tiles;
